import React, {PureComponent} from 'react';
import FontAwesome from 'react-fontawesome';
import Table from '../../../components/Table';
import {Col, Button, Row, Card, CardBody,Badge,ButtonGroup,Popover, PopoverBody, PopoverHeader} from 'reactstrap';
import * as http from '../../../modules/http';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {
    customers_delete
} from '../../../redux/actions/CustomersActions';
import Modal from './Modal';
import * as TextManager from "../../../modules/languages/TextManager";
import SalesItem from "../../sales/SalesItem";
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import * as environment from "../../../modules/environment";
import arrayToCsv from "../../../modules/arrayToCsv";


const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
    TablePaginationActions,
);


const CustomPagination = withStyles(theme => ({
    root: {
        float: 'left'
    },
    '@media screen and (max-width: 480px)': {
        root: {
            //backgroundColor: theme.palette.common.black,
            marginLeft: '-50px'
        }
    }

}))(TablePagination);


class CustomersTable extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            deals: [],
            selectedID: 0,
            saving: false,
            error: false,
            page: 0,
            rowsPerPage: 20,
            popoverOpen: 0,
            popoverPhoneOpen: 0,
            popoverWatsappOpen: 0
        };

        this.timerID = 0;
    }

    componentDidMount() {
        this.timerID = setInterval(() => this.handleRefresh(), 7*60*1000);
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    editCustomer = (customer) => {

        //console.log("editCustomer");

        http.postToServer(
            'customers/cancel_edit?customerId='+this.state.selectedID+'&storeId='+this.props.userData.data.id,
            {},
            (response) => {
                //console.log(response.data);
                //this.setState({now_handle_by: response.data[0].now_handle_by})
            },
            (response) => {
                //console.log('error ' + response.data);
                //this.setState({errorText: response.data.message})
            }
        );

        if (customer.id === this.state.selectedID) {
            this.setState({selectedID: 0});
        }
        else {
            this.setState({selectedID: customer.id});
        }
    };

    deleteCustomer = (customer) => {
        //abc
        http.postToServer(
            'customers/delete',
            {id: customer.id, type: 0},
            (response) => {
                this.props.dispatch(customers_delete(customer.id));

            },
            (response) => {
                console.log('error delete creative');
            }
        );

    };

    getStatusNew = (status) => {
        if (status === 0)
            return TextManager.getCurrentTextResource().Customers.notActive;
        else if (status === 1)
            return TextManager.getCurrentTextResource().Customers.active;
        else if (status === 2)
            return TextManager.getCurrentTextResource().Customers.dealStarted;
        else if(status === 3)
            return 'בטיפול';
        else
            return 'ERROR';
    };

    getStatus = (status, autoSpecial) => {
        if (status === 1 || status === 11)
            return TextManager.getCurrentTextResource().Text.new;
        else if(status === 2 || (!autoSpecial && status === 10))
            return TextManager.getCurrentTextResource().Text.active;
        else if(status === 3)
            return TextManager.getCurrentTextResource().Text.inactive;
        else if(status === 4 || (status === 12 && !autoSpecial))
            return TextManager.getCurrentTextResource().Text.maintenance;
        else if(status === 5 || (status === 13 && !autoSpecial))
            return TextManager.getCurrentTextResource().Text.halfDone;
        else if(status === 6)
            return "בטיפול";
        else if(status === 10 && autoSpecial)
            return "פעיל אוטו";
        else if(status === 12 && autoSpecial)
            return "הזמנה עלתה אוטומציה";
        else if(status === 13 && autoSpecial)
            return "בוצע חלקית אוטומציה";
    };

    getSecondStatus = (status) => {
        if (status === 1)
            return TextManager.getCurrentTextResource().Customers.yes;
        else
            return TextManager.getCurrentTextResource().Customers.no;
    };

    getStatusColor = (status) => {
        if (status === 1 || status === 11)
            return "warning";
        else if(status === 2 || status === 10)
             return "success";
        else if(status === 3)
            return "danger";
        else if(status === 4 || status === 12)
            return "primary";
        else
            return "other";
    };

    getSecondStatusColor = (status) => {
        if (status === 1)
            return "success";
        else
            return "danger";
    };

    togglePopover = (id) => {

        //console.log("togglePopover")

        if(this.state.popoverOpen !== 0) {
            this.setState({popoverOpen: 0});
        }
        else {
            this.setState({popoverOpen: id});
        }
    };

    togglePopoverPhone = (id) => {

        //console.log("togglePopover")

        if(this.state.popoverPhoneOpen !== 0) {
            this.setState({popoverPhoneOpen: 0});
        }
        else {
            this.setState({popoverPhoneOpen: id});
        }
    };

    togglePopoverWatsapp = (id) => {

        //console.log("togglePopover")

        if(this.state.popoverWatsappOpen !== 0) {
            this.setState({popoverWatsappOpen: 0});
        }
        else {
            this.setState({popoverWatsappOpen: id});
        }
    };

    getRow(customer, index, isDelete, isDealReminder) {

        /*if(customer.storePhone !== "")
            console.log(customer)*/
        return (

            <React.Fragment key={customer.id}>

                <tr key={customer.id} onClick={() => this.editCustomer(customer)}>

                    {isDelete && <td>
                        <Modal color='danger' title='Are you sure!'
                                        approve={() => this.deleteCustomer(customer)}
                                        message={'Delete Customer ' + customer.name + '?'}>
                            <Button color='danger' size='sm' onClick={(e) => e.preventDefault()}
                                    style={{padding: "0px 15px"}}>
                                <FontAwesome name='times'/>
                            </Button>

                        </Modal>
                    </td>
                    }


                    {/*<td>
                        <Badge color={this.getSecondStatusColor(customer.secondStatus)}
                        >{this.getSecondStatus(customer.secondStatus)}</Badge>
                    </td>*/}
                    <td>
                        <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
                            {(customer.lu_by_user_type !== undefined && customer.lu_by_user_type !== null) && customer.lu_by_user_type === environment.ListUserTypesEnum.Store &&
                            <i className="far fa-envelope" style={{ fontSize: '20px', marginRight: '5px'}}></i>
                            }
                            {(customer.deal_reminder !== undefined && customer.deal_reminder !== null && customer.deal_reminder !== 0 && isDealReminder) &&
                            <i className="far fa-bell" style={{ fontSize: '20px', marginRight: '5px'}}></i>
                            }
                            {(customer.deal_image !== undefined && customer.deal_image !== null && customer.deal_image !== 0 && customer.passport === "") &&
                            <i className="fas fa-camera" style={{ fontSize: '20px', marginRight: '5px'}}></i>
                            }
                            {((this.props.userData && this.props.userData.data && this.props.userData.data.isAdmin) || environment.ListManagersFeatures.includes(this.props.userData.data.id))
                                && customer.status === 11 &&
                            <i className="fas fa-screwdriver" style={{ fontSize: '20px', marginRight: '5px'}}></i>
                            }
                            <Badge color={this.getStatusColor(customer.status)} //onClick={() => this.changeStatus(customer.id)} style={(this.props.userData.data.isManager || this.props.userData.data.isAdmin) ? {cursor: 'pointer'} : {}}
                            >{this.getStatus(customer.status, isDealReminder)}</Badge>
                        </div>

                    </td>
                    <td>{customer.numOfLines === 0 ? 1 : customer.numOfLines}</td>
                    <td>{customer.providerName}</td>
                    <td>{customer.name}</td>
                    {isDealReminder && <td>{customer.managerName !== "" && <i id={"PopoverManager"+customer.id} className="fa fa-question-circle-o"
                                                                              style={{ fontSize: '18px', marginRight: '8px', cursor: 'pointer'}}
                                                                              onClick={(e) =>
                                                                              {
                                                                                  e.stopPropagation();
                                                                                  this.togglePopover(customer.id)}
                                                                              }></i>}
                        {customer.storePhone !== "" && <i id={"PopoverPhone"+customer.id} className="fa fa-phone"
                                                           style={{ fontSize: '18px', marginRight: '8px', cursor: 'pointer'}}
                                                           onClick={(e) =>
                                                           {
                                                               e.stopPropagation();
                                                               this.togglePopoverPhone(customer.id)}
                                                           }></i>}
                        {customer.watsapp !== "" && customer.watsapp !== null && <i id={"PopoverWatsapp"+customer.id} className="fa fa-whatsapp"
                                                          style={{ fontSize: '18px', marginRight: '8px', cursor: 'pointer'}}
                                                          onClick={(e) =>
                                                          {
                                                              e.stopPropagation();
                                                              this.togglePopoverWatsapp(customer.id)}
                                                          }></i>}
                        {customer.managerName !== "" && <Popover
                            placement="top"
                            isOpen={this.state.popoverOpen === customer.id}
                            target={"PopoverManager" + customer.id}
                            toggle={() => this.togglePopover(0)}
                        >
                            <PopoverHeader>שם מנהל</PopoverHeader>
                            <PopoverBody>{customer.managerName}
                            </PopoverBody>
                        </Popover>}
                        {customer.storePhone !== "" && <Popover
                            placement="top"
                            isOpen={this.state.popoverPhoneOpen === customer.id}
                            target={"PopoverPhone" + customer.id}
                            toggle={() => this.togglePopoverPhone(0)}
                        >
                            <PopoverBody>{customer.storePhone}
                            </PopoverBody>
                        </Popover>}
                        {customer.watsapp !== "" && customer.watsapp !== null && <Popover
                            placement="top"
                            isOpen={this.state.popoverWatsappOpen === customer.id}
                            target={"PopoverWatsapp" + customer.id}
                            toggle={() => this.togglePopoverWatsapp(0)}
                        >
                            <PopoverBody><li className='sidebar__link' style={{height: 'auto', width: 'auto'}}
                                             onClick={(e) => {
                                                 e.preventDefault();
                                                 window.open(customer.watsapp, '_blank');
                                             }}>
                                {customer.watsapp}
                            </li>
                            </PopoverBody>
                        </Popover>}
                        {customer.storeName}
                    </td>}
                    {!isDealReminder && <td>{customer.storeName}</td>}
                    {this.props.userData.data.isAdmin && <td>{customer.manageDay}</td>}
                    <td>{customer.updateDay}</td>
                    <td>{customer.customerId}</td>
                    <td>{customer.id.toString(16)}</td>

                </tr>

                {customer.id === this.state.selectedID &&
                <tr key={customer.id + 2000}>
                    <td colSpan="12">
                        <SalesItem customer={customer} onClose={() => {this.setState({selectedID : 0}); this.props.refreshData();}} />
                    </td>
                </tr>
                }
            </React.Fragment>
        );
    }

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    buildLinesString = (lines) => {
        let resDeals = [];

        if (lines.length > 0) {
            let filterNames = Object.getOwnPropertyNames(lines[0]);

            for (let indx in lines) {
                let str = "";
                for (let indx2 in filterNames) {
                    let col = filterNames[indx2];
                    if (lines[indx][col] !== "") {
                        if(col === 'customerNumber') {
                            //str += " " + lines[indx][col] + 'מספר מנוי: ';
                            str += 'מספר מנוי: ' + lines[indx][col] + ' ';
                        }
                        else if (col === 'simNumber') {
                            str += 'מספר: ' + lines[indx][col] + ' ';
                        }
                        else if (col === 'status') {
                            str += "סטטוס: " + this.getStatus(lines[indx][col]) + ' ';
                        }
                        else if (col === 'secondStatus') {
                            str += "זמניים פתוחים: " + this.getSecondStatus(lines[indx][col]) + ' ';
                        }
                        else if (col === 'notes') {
                            str += "הערות: " + lines[indx][col];
                        }
                        else if(col === 'deal') {
                            str += ' ' + lines[indx][col].text + ' ' + lines[indx][col].amount + ' ';
                        }
                        else {
                            if (lines[indx][col] !== null) {
                                str += lines[indx][col] + " ";
                            }
                        }
                    }
                }

                if (str !== "") {
                    resDeals.push(str);
                }
            }
        }

        return resDeals;
    };

    buildLinesString2 = (line) => {
        let str = "";
        let filterNames = Object.getOwnPropertyNames(line);

        for (let indx2 in filterNames) {
            let col = filterNames[indx2];
            if (line[col] !== "") {
                if(col === 'customerNumber') {
                    //str += " " + lines[indx][col] + 'מספר מנוי: ';
                    str += 'מספר מנוי: ' + line[col] + ' ';
                }
                else if (col === 'simNumber') {
                    str += 'מספר: ' + line[col] + ' ';
                }
                else if (col === 'status') {
                    str += "סטטוס: " + this.getStatus(line[col]) + ' ';
                }
                else if (col === 'secondStatus') {
                    str += "זמניים פתוחים: " + this.getSecondStatus(line[col]) + ' ';
                }
                else if (col === 'notes') {
                    str += "הערות: " + line[col];
                }
                else if(col === 'deal') {
                    str += ' ' + line[col].text + ' ' + line[col].amount + ' ';
                }
                else {
                    if (line[col] !== null) {
                        str += line[col] + " ";
                    }
                }
            }
        }

        return str;
    };

    buildLinesString3 = (line, param) => {
        let str = "";
        let filterNames = Object.getOwnPropertyNames(line);

        for (let indx2 in filterNames) {
            let col = filterNames[indx2];

            //console.log(col);
            if (line[col] !== "") {
                if(col === param) {
                    str += String(line[col]);
                }
                else {
                }
            }
        }

        return str;
    };

    handleDownload = () => {

        let dataTmp = this.props.data;

        //console.log(dataTmp);

        let data = [];
        if(dataTmp.length > 0 ) {

            for (let indx in dataTmp) {

                if(dataTmp[indx].lines && dataTmp[indx].lines != null && dataTmp[indx].lines !== undefined) {
                    let tmpHandleName = this.props.utilsData.data.handleName.find(e => e.value === parseInt(this.buildLinesString3(dataTmp[indx].lines[0], 'handleName')));

                    for (let indx2 in dataTmp[indx].lines) {

                        let obj = {...dataTmp[indx]};

                        obj.lines = this.buildLinesString3(dataTmp[indx].lines[indx2], 'customerNumber');
                        obj.question = this.buildLinesString3(dataTmp[indx].lines[indx2], 'question');
                        obj.notes = this.buildLinesString3(dataTmp[indx].lines[indx2], 'notes');
                        obj.simNumber =  dataTmp[indx].lines[indx2].isSimOrSend === 2 ? 'eSim' : this.buildLinesString3(dataTmp[indx].lines[indx2], 'simNumber') + "\t";
                        obj.uniqueId = this.buildLinesString3(dataTmp[indx].lines[indx2], 'uniqueId');
                        obj.handleName = tmpHandleName === undefined ? '' : tmpHandleName.label;

                        //obj.status = this.getStatus(dataTmp[indx].status);
                        obj.status = this.getStatusNew(dataTmp[indx].lines[indx2].status);

                        obj.secondStatus = this.getSecondStatus(dataTmp[indx].secondStatus);

                        obj.dealText = dataTmp[indx].lines[indx2].deal.text;
                        obj.dealAmount = dataTmp[indx].lines[indx2].deal.amount;

                        if (this.props.userData && this.props.userData.data.isAdmin) {
                            if (dataTmp[indx].lines[indx2].isNewNumber === 0) {
                                obj.newOrPresent = "חדש"
                            } else {
                                obj.newOrPresent = "ניוד"
                            }
                        }

                        if(dataTmp[indx].city !== 0 || dataTmp[indx].cityName !== null) {
                            obj.address = dataTmp[indx].cityName + ', ' + dataTmp[indx].streetName + ' ' + dataTmp[indx].number + ' דירה ' + dataTmp[indx].flat;
                        }

                        data.push(obj);
                    }
                }
                else {
                    let obj = {...dataTmp[indx]};

                    obj.lines = 1;
                    obj.numOfLines = 1;
                    obj.status = this.getStatus(dataTmp[indx].status);
                    obj.secondStatus = this.getSecondStatus(dataTmp[indx].secondStatus);

                    if((dataTmp[indx].internet === undefined || dataTmp[indx].internet === null) && (dataTmp[indx].tv === undefined || dataTmp[indx].tv === null)) {
                        obj.dealText = "";
                    }
                    else {
                        obj.dealText = (dataTmp[indx].internet !== undefined && dataTmp[indx].internet !== null) ? dataTmp[indx].internet.deal : dataTmp[indx].tv.deal;
                    }

                    if(dataTmp[indx].city !== 0 || dataTmp[indx].cityName !== null) {
                        obj.address = dataTmp[indx].cityName + ', ' + dataTmp[indx].streetName + ' ' + dataTmp[indx].number + ' דירה ' + dataTmp[indx].flat;
                    }

                    data.push(obj);
                }
            }

            let excludeKeyArr = ['manageDay', 'tv', 'internet', 'chat', 'now_handle_by', 'careBy', 'lastUpdateBy', 'as_new',
                'lu_by_user_type', 'dealType', 'given_number', 'chatDealReminder', 'duplicate_list', 'deal_reminder', 'external_id',
                'city', 'cityName', 'street', 'streetName', 'number', 'flat', 'floor', 'deal_image', 'autoDealDetail', 'autoMes',
                'watsapp', 'isAuto', 'eSimDetail'];

            if (this.props.userData && !this.props.userData.data.isAdmin) {
                excludeKeyArr.push('admin_comment');
                excludeKeyArr.push('managerName');
            }

            let csvContent = arrayToCsv({
                data,
                translated: {
                    ...TextManager.getCurrentTextResource().Customers,
                },
                boolTotext: ['question'],
                excludeKey: excludeKeyArr
            });

            let link = window.document.createElement("a");
            link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent));
            link.setAttribute("download", "download.csv");
            link.click();
        }
    };

    handleRefresh = () => {

        //console.log("Timer = " + this.timerID  + " ID = " +this.state.selectedID);

        /*if(this.props.userData && this.props.userData.data) {

            // Manager or admin refresh always
            if(this.props.userData.data.isAdmin || this.props.userData.data.isManager) {
                this.props.refreshData();
            }
            // Store refresh only if is not inside the deal
            else {
                if(this.state.selectedID === 0) {
                    this.props.refreshData();
                }
            }
        }*/

        if(this.props.userData && this.props.userData.data) {
            // New approach, any user refresh only if is not inside the deal
            if(this.state.selectedID === 0) {
                this.props.refreshData();
            }
        }
    };

    render() {

        //console.log(this.state.popoverOpen);

        const {rowsPerPage, page} = this.state;

        const isDelete = this.props.userData && (this.props.userData.data.isManager || this.props.userData.data.isAdmin);

        let isDealReminder = false;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.id) {
            if( environment.ListManagersFeatures.includes(this.props.userData.data.id) || this.props.userData.data.isAdmin) {
                isDealReminder = true;
            }
        }

        let rows = this.props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((customer, index) =>
            this.getRow(customer,index,isDelete,isDealReminder)
        );

        let totalLines = this.props.data.map(a => a.numOfLines === 0 ? 1 : a.numOfLines).reduce((a, b) => a + b, 0);

        let isAdding = this.state.windowType === 2 && this.state.selectedID === 0;

        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                <Card>

                    <CardBody>
                        {/*isAdding &&
                        <EditOfferForm
                            onClose={() => this.setState({selectedID: 0, windowType: 0, generatedTemplate: ''})}/>
                        */}

                        { !isAdding &&
                        <span>
                            <Table responsive className='table-hover table--bordered'>
                                <thead>
                                {"סה\"כ קוים: " + totalLines}
                                <tr>

                                    {/*<th>{TextManager.getCurrentTextResource().Customers.storeId}</th>
                                    <th>{TextManager.getCurrentTextResource().Customers.id}</th>*/}

                                    {isDelete && <th></th>}

                                    {/*<th>{TextManager.getCurrentTextResource().Customers.secondStatus}</th>*/}
                                    <th>{TextManager.getCurrentTextResource().Customers.status}</th>
                                    <th>{TextManager.getCurrentTextResource().Customers.numOfLines}</th>
                                    <th>{TextManager.getCurrentTextResource().Customers.provider}</th>
                                    <th>{TextManager.getCurrentTextResource().Customers.name}</th>
                                    <th>{TextManager.getCurrentTextResource().Customers.storeName}</th>
                                    {this.props.userData.data.isAdmin && <th>{TextManager.getCurrentTextResource().Customers.manageDay}</th>}
                                    <th>{TextManager.getCurrentTextResource().Customers.updateDay}</th>
                                    <th>{TextManager.getCurrentTextResource().Customers.id}</th>
                                    <th>מספר העסקה</th>

                                </tr>
                                </thead>
                                <tbody>
                                {rows}
                                </tbody>
                            </Table>
                                <Row>
                                    <Col md={6} sm={12} lg={6} xs={12}>
                                        <CustomPagination
                                            labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                            rowsPerPageOptions={[5, 10, 20, 50, 100, 200]}
                                            component="div"
                                            count={this.props.data.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            backIconButtonProps={{
                                                'aria-label': 'Previous Page',
                                            }}
                                            nextIconButtonProps={{
                                                'aria-label': 'Next Page',
                                            }}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActionsWrapped}
                                        />
                                    </Col>
                                    <Col md={6} sm={12} lg={6} xs={12}>
                                        <ButtonGroup className='btn-group--icons'
                                                     style={{marginTop: "10px", float: "right"}}>
                                            <Button outline color='primary'
                                                    onClick={this.handleDownload}>{TextManager.getCurrentTextResource().Utils.download}</Button>
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                        </span>
                        }
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.customers.status,
        utilsData: state.utilsData,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(CustomersTable))